import { get } from 'lodash';

import BackendConnector from './backendConnector';

export default class ContactCandidateHttpService {
    static getContactEmailContextData({ positionId, talentId }) {
        return BackendConnector.post('/candidate/contact/contextData', { positionId, talentId });
    }

    static getContextDataCharsCount({ positionId, talentId, isInMail = false }) {
        return BackendConnector.get('/candidate/contact/contextData/charsCount', { params: { positionId, talentId, isInMail } });
    }

    static getContextDataMessage({ positionId, talentId, isInMail = false }) {
        return BackendConnector.post('/candidate/contact/contextData/contextDataMessage', { positionId, talentId, isInMail });
    }

    static async contactCandidatesWithHiddenDetailsByEmail({
        positionId,
        message,
        recipientsData,
        emailData,
        duplicateEmailCheckBeforeSend,
        forceDuplicateSendMode,
    }) {
        const response = await BackendConnector.post('/candidate/contact/email/hidden', {
            positionId,
            message,
            recipientsData,
            emailData,
            duplicateEmailCheckBeforeSend,
            forceDuplicateSendMode,
        });

        const taskId = get(response, 'taskId');

        if (!taskId) {
            throw new Error('Task didn\'t start');
        }

        const result = await BackendConnector.pollUntilTaskFinished(taskId);
        return result;
    }

    static sendTestContactCandidateEmail(campaignId, contactCandidateData, isBulkMode) {
        return BackendConnector.post('/candidate/contact/testEmail', { campaignId, isBulkMode, ...contactCandidateData });
    }

    static addCandidateContactCampaignSentMessage({
        contactType = 'manual',
        sentMessage,
        positionId,
        talentId,
    }) {
        return BackendConnector.post('/candidate/contact/sentMessage/add', {
            contactType,
            sentMessage,
            positionId,
            talentId,
        });
    }

    static updateCandidateContactStatus(talentId, type, value, status) {
        return BackendConnector.post('/candidate/contact/status', {
            talentId, type, value, status,
        });
    }

    static updateCandidateContactDataStatuses(data) {
        return BackendConnector.put('/candidate/contacts/statuses', data);
    }
}
